import clsx from "clsx";
import * as React from "react";

interface Props extends React.PropsWithChildren {
  lastItem?: boolean;
  className?: string;
}
export const FormItem: React.FC<Props> = ({ children, lastItem, className = "" }) => {
  return (
    <div
      className={clsx(
        {
          "cpln-ant-form-item": true,
          "cpln-ant-form-item-last": lastItem,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};
